import { render } from "./ConfirmEmailStep2.vue?vue&type=template&id=1005b5ce"
import script from "./ConfirmEmailStep2.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailStep2.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bylex_platform/account/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__